import { NavigationList } from '@/entities/NavigationList/ui/NavigationList.jsx'
import './ui/NavigationList.scss'
export default NavigationList
